import React, { useState, useEffect } from 'react';
import Form from './form/Start_form';
import { useParams } from 'react-router-dom';
import HorizontalNav from '../servizi/HorizontalNav';
import data from '../servizi/data/output';
import { MDBContainer, MDBRow } from 'mdb-react-ui-kit';

import { useRef } from "react";
import { useLocation } from "react-router-dom";


const ContattiForm = () => {

	const [urlPage, setUrlPage] = useState(window.location.pathname)
	const [title, setTitle] = useState(false)
	const [horNav, setHorNav] = useState(false)

	const location = useLocation();
	const sectionRef = useRef(null);

	useEffect(() => {
		if (location.hash) {
		const id = location.hash.slice(1);

		sectionRef.current &&
			sectionRef.current.id === id &&
			sectionRef.current.scrollIntoView();
		}
	}, [location]);

	useEffect(
		() => {
				setUrlPage(window.location.pathname)
				// console.log(urlPage)
				if (urlPage.includes('preventivo')) {
					setTitle(`Invia una richiesta di preventivo allo Studio Notarile Falcinelli - Notaio Treviso`)
					setHorNav(true)
				} 
				if (urlPage.includes('informazioni')) {
					setTitle(`Invia una richiesta di informazioni allo Studio Notarile Falcinelli - Notaio Treviso`)
					setHorNav(true)
				}
				if (!urlPage.includes('informazioni') && !urlPage.includes('preventivo')) {
					setTitle(`Invia una richiesta allo Studio Notarile Falcinelli - Notaio Treviso`)
					setHorNav(false)
				}
		},
		[],
	); 

  const { servizioID } = useParams();
  return (
			<MDBContainer>
				{data.map( servizio => {
					if (servizioID === servizio.link) {
						return (
						<>
								{horNav ? 
									<HorizontalNav
									link1={'/servizi'}
									name1={'Servizi'}
									symbol1={'>'}
									link2={''}
									name2={''}
									symbol2={''}
									pageName={servizio.name} /> 
									: 
									null
								}
								
								<Form 
									title={title}
									servizioName={servizio.name}
								/>

								<MDBRow className='mt-5'>
									<h2>Informazioni - {servizio.name}</h2>
									{window.location.pathname.includes('preventivo') ? 
										<h3 className='publi'>Disponibilità, affidabilità e preventivi concorrenziali</h3>
										: null
									}
									<h3 className='publi'>Notaio a Treviso - Il notaio di Treviso e provincia</h3>
								</MDBRow>
								<MDBRow className='mt-2'>
									{window.location.pathname.includes('informazioni') ? 
										<h4 className='publiInfo'>Lo studio notarile Falcinelli fornisce ai propri clienti la più completa ed esaustiva consulenza giuridica richiesta per ogni singolo caso concreto, sia in relazione agli atti che i clienti stessi richiedono di stipulare con il ministero del Notaio medesimo e sia per singole fattispecie che non necessariamente richiedono l’intervento del Notaio quale pubblico ufficiale.
										
										L’attività di consulenza può essere richiesta al Notaio Falcinelli tramite la fissazione di un colloquio privato presso la <a href='https://www.notaio-treviso.com/contatti' title='contatti notaio Treviso' className='hrefA'>nostra sede</a> e può essere rilasciata anche nella forma di pareri scritti in materia di diritto civile, diritto commerciale, diritto internazionale privato e diritto tributario.</h4>
										: null
									}
								</MDBRow>
								<MDBRow className='articoloBoxMobile mt-1  mb-5'>
									<div className="content post_content" dangerouslySetInnerHTML={{ __html: servizio.corpus }}></div>
								</MDBRow>
						</>
							
					);
					}
				})}
				{
					window.location.pathname === '/' || window.location.pathname === '/contatti' ? 
						<div id="contact">
							<Form 
								title={title}
							/>
						</div>
					: null
				}
		</MDBContainer>
	);
}

export default ContattiForm;

